module.exports = __webpack_public_path__ + "img/download-on-the-app-store.c9b35e2f.svg";